const InputAlert = ({ type, message }) => {
  return (
    <div className="text-sm">
      <span className={`text-${type === "error" ? "red" : type === "warning" ? "yellow" : "green"}-500`}>
        {message}
      </span>
    </div>
  );
};

export default InputAlert;
